// Temporary mock data — remove once the search API is deployed
import { ISourcingCompanyRow } from '../../../schemas/SourcingListItems.schema';

const MOCK_LIST_ID = 'mock-search';

export const SOURCING_SEARCH_MOCK_DATA: readonly ISourcingCompanyRow[] = [
  {
    id: 'mock-1',
    listId: MOCK_LIST_ID,
    enrichmentId: '1f849a08-dd6b-4e6a-86ad-55629ba3df0c',
    name: '2048 Ventures',
    legalName: '2048 Ventures',
    domain: '2048.vc',
    website: 'https://2048.vc',
    linkedinUrl: 'https://linkedin.com/company/2048vc',
    logoUrl: 'https://images.crunchbase.com/image/upload/t_cb-default-original/wo23qlltbqwu6w58fheg',
    shortDescription: '2048 Ventures is a thesis-driven venture capital firm.',
    longDescription: null,
    primaryLocation: 'New York, NY 10001, USA',
    secondaryLocation: null,
    headcount: '51',
    foundedYear: 2019,
    totalFunding: 0,
    numFundingRounds: 0,
    latestFundingStage: 'UNKNOWN',
    industry: 'Artificial Intelligence (AI),B2B,Biotechnology,Health Care,Venture Capital',
    sector: null,
    annualRevenue: null,
    ceoName: null,
    founders: null,
    acquired: false,
    acquiredBy: null,
    aliases: null,
    allInvestors: null,
    emails: null,
    phones: null,
    crunchbaseUrl: null,
    pitchbookUrl: null,
    facebookUrl: 'https://www.facebook.com/alexiskold',
    twitterUrl: 'https://x.com/2048vc',
    lastEnrichmentRequestId: null,
    lastFundingRaised: null,
    postValuation: null,
    recentNews: null,
  },
  {
    id: 'mock-2',
    listId: MOCK_LIST_ID,
    enrichmentId: 'e1ff55af-d18c-48d2-b43d-a960005307a9',
    name: 'Pepperi',
    legalName: 'PEPPERI LTD',
    domain: 'pepperi.com',
    website: 'http://pepperi.com',
    linkedinUrl: 'https://linkedin.com/company/pepperi-com',
    logoUrl:
      'https://images.crunchbase.com/image/upload/t_cb-default-original/v1454428855/lilvnizfi5wtrrmfr7gb.jpg',
    shortDescription: 'Pepperi is a B2B sales platform for brands and wholesale distributors.',
    longDescription: null,
    primaryLocation: 'The Continental NYC, 106 W 32nd St 2nd Fl office, New York, NY 10001, USA',
    secondaryLocation: null,
    headcount: '61',
    foundedYear: 2012,
    totalFunding: 0,
    numFundingRounds: 0,
    latestFundingStage: 'UNKNOWN',
    industry: 'B2B,E-Commerce,Mobile Apps,SaaS,Sales Automation,Software,Wholesale',
    sector: null,
    annualRevenue: null,
    ceoName: null,
    founders: null,
    acquired: true,
    acquiredBy: null,
    aliases: null,
    allInvestors: null,
    emails: ['info@pepperi.com'],
    phones: ['1-800-644-9146'],
    crunchbaseUrl: null,
    pitchbookUrl: null,
    facebookUrl: 'https://www.facebook.com/PepperiHQ',
    twitterUrl: 'https://x.com/PepperiHQ',
    lastEnrichmentRequestId: null,
    lastFundingRaised: null,
    postValuation: null,
    recentNews: null,
  },
  {
    id: 'mock-3',
    listId: MOCK_LIST_ID,
    enrichmentId: 'c0201ba6-9676-45f2-a6b2-92de404ffd84',
    name: 'Reachdesk',
    legalName: 'Reachdesk Holdings Inc.',
    domain: 'reachdesk.com',
    website: 'https://reachdesk.com',
    linkedinUrl: 'https://linkedin.com/company/reachdesk',
    logoUrl: 'https://images.crunchbase.com/image/upload/t_cb-default-original/rema3xxkluewcwzgro8r',
    shortDescription:
      'Enabling B2B companies to deliver the moments that matter at scale through data-driven direct mail and gifting.',
    longDescription: null,
    primaryLocation: 'New York, NY 10016, USA',
    secondaryLocation: null,
    headcount: '111',
    foundedYear: 2018,
    totalFunding: 49_000_000,
    numFundingRounds: 2,
    latestFundingStage: 'SERIES_B',
    industry: 'B2B,Marketing Automation,SaaS,Sales Automation,Software',
    sector: null,
    annualRevenue: null,
    ceoName: null,
    founders: null,
    acquired: false,
    acquiredBy: null,
    aliases: null,
    allInvestors: null,
    emails: null,
    phones: ['+1 315 273 4734'],
    crunchbaseUrl: null,
    pitchbookUrl: null,
    facebookUrl: 'https://www.facebook.com/ReachdeskHQ/',
    twitterUrl: 'https://x.com/reachdeskhq',
    lastEnrichmentRequestId: null,
    lastFundingRaised: null,
    postValuation: null,
    recentNews: null,
  },
  {
    id: 'mock-4',
    listId: MOCK_LIST_ID,
    enrichmentId: 'b2d5d200-e805-47cc-aaac-43903ff0c272',
    name: 'Tabs',
    legalName: 'Tabs Platform Inc.',
    domain: 'tabs.com',
    website: 'https://www.tabs.com',
    linkedinUrl: 'https://linkedin.com/company/teamtabs',
    logoUrl:
      'https://images.crunchbase.com/image/upload/t_cb-default-original/71ab283e34a74931a3b037b4919e4e41',
    shortDescription: 'Tabs is the first AI Driven Revenue Automation Platform for B2B Finance',
    longDescription: null,
    primaryLocation: 'New York, NY, USA',
    secondaryLocation: null,
    headcount: '165',
    foundedYear: 2023,
    totalFunding: 92_000_000,
    numFundingRounds: 4,
    latestFundingStage: 'SERIES_B',
    industry: 'Accounting,Artificial Intelligence (AI),Enterprise Software,FinTech,SaaS,Software',
    sector: null,
    annualRevenue: null,
    ceoName: null,
    founders: null,
    acquired: false,
    acquiredBy: null,
    aliases: null,
    allInvestors: null,
    emails: ['support@tabs.inc'],
    phones: ['+1 612-790-5022'],
    crunchbaseUrl: null,
    pitchbookUrl: null,
    facebookUrl: null,
    twitterUrl: null,
    lastEnrichmentRequestId: null,
    lastFundingRaised: null,
    postValuation: null,
    recentNews: null,
  },
  {
    id: 'mock-5',
    listId: MOCK_LIST_ID,
    enrichmentId: '18347d2b-3515-429b-8e7e-ba9a50d46362',
    name: 'Upflow',
    legalName: 'Upflow Inc.',
    domain: 'upflow.io',
    website: 'https://upflow.io',
    linkedinUrl: 'https://linkedin.com/company/upflowhq',
    logoUrl: 'https://images.crunchbase.com/image/upload/t_cb-default-original/thwg5cyza5fjv1ilixgz',
    shortDescription: 'Upflow is a technology company building a payment platform for B2B businesses.',
    longDescription: null,
    primaryLocation: '33 Irving Pl, New York, NY 10003, USA',
    secondaryLocation: null,
    headcount: '61',
    foundedYear: 2018,
    totalFunding: 22_872_238,
    numFundingRounds: 6,
    latestFundingStage: 'SERIES_A',
    industry: 'B2B,Billing,E-Commerce Platforms,Financial Services,FinTech,Payments,SaaS,Software',
    sector: null,
    annualRevenue: null,
    ceoName: null,
    founders: null,
    acquired: false,
    acquiredBy: null,
    aliases: null,
    allInvestors: null,
    emails: ['hello@upflow.io'],
    phones: null,
    crunchbaseUrl: null,
    pitchbookUrl: null,
    facebookUrl: 'https://www.facebook.com/upflowHQ/',
    twitterUrl: 'https://x.com/UpflowHQ',
    lastEnrichmentRequestId: null,
    lastFundingRaised: null,
    postValuation: null,
    recentNews: null,
  },
  {
    id: 'mock-6',
    listId: MOCK_LIST_ID,
    enrichmentId: '77a4f439-5a86-4abb-b15f-9e5ac4b2d4e6',
    name: 'Vitally',
    legalName: 'Vitally, Inc.',
    domain: 'vitally.io',
    website: 'https://vitally.io',
    linkedinUrl: 'https://linkedin.com/company/vitally.io',
    logoUrl: 'https://images.crunchbase.com/image/upload/t_cb-default-original/jdp2ql4ur2wmudnckppg',
    shortDescription:
      'Vitally is a customer success platform designed for maximizing productivity, visibility and collaboration.',
    longDescription: null,
    primaryLocation: 'Brooklyn, NY 11249, USA',
    secondaryLocation: null,
    headcount: '121',
    foundedYear: 2017,
    totalFunding: 39_320_000,
    numFundingRounds: 5,
    latestFundingStage: 'SERIES_B',
    industry: 'Analytics,B2B,Data Visualization,Internet,Productivity Tools,SaaS',
    sector: null,
    annualRevenue: null,
    ceoName: null,
    founders: null,
    acquired: false,
    acquiredBy: null,
    aliases: null,
    allInvestors: null,
    emails: ['hello@vitally.io'],
    phones: null,
    crunchbaseUrl: null,
    pitchbookUrl: null,
    facebookUrl: 'https://www.facebook.com/Vitally.io',
    twitterUrl: 'https://x.com/vitally_io',
    lastEnrichmentRequestId: null,
    lastFundingRaised: null,
    postValuation: null,
    recentNews: null,
  },
  {
    id: 'mock-7',
    listId: MOCK_LIST_ID,
    enrichmentId: '80cd5925-6cf9-4218-893f-7547f9444a86',
    name: 'BetterCloud',
    legalName: 'BetterCloud, Inc.',
    domain: 'bettercloud.com',
    website: 'https://bettercloud.com',
    linkedinUrl: 'https://linkedin.com/company/bettercloud',
    logoUrl: 'https://images.crunchbase.com/image/upload/t_cb-default-original/nwjwqtkauy5qgcwkkeoi',
    shortDescription:
      'BetterCloud is a SaaS Operations leader: Transform employee experience, centralize data protection, and maximize operational efficiency.',
    longDescription: null,
    primaryLocation: '330 7th Ave 14th Floor, New York, NY 10001, USA',
    secondaryLocation: null,
    headcount: '145',
    foundedYear: 2011,
    totalFunding: 186_850_000,
    numFundingRounds: 10,
    latestFundingStage: 'SERIES_F',
    industry:
      'Apps,Business Process Automation,Cloud Security,Enterprise Software,IT Management,SaaS,Software',
    sector: null,
    annualRevenue: null,
    ceoName: null,
    founders: null,
    acquired: true,
    acquiredBy: null,
    aliases: null,
    allInvestors: null,
    emails: ['info@bettercloud.com'],
    phones: ['(888) 999-0805'],
    crunchbaseUrl: null,
    pitchbookUrl: null,
    facebookUrl: 'http://www.facebook.com/BetterCloud',
    twitterUrl: 'https://x.com/bettercloud',
    lastEnrichmentRequestId: null,
    lastFundingRaised: null,
    postValuation: null,
    recentNews: null,
  },
  {
    id: 'mock-8',
    listId: MOCK_LIST_ID,
    enrichmentId: 'b4e21f4d-cc43-47f2-bff6-71a37730b6d9',
    name: 'Chili Piper',
    legalName: 'Chili Piper, Inc.',
    domain: 'chilipiper.com',
    website: 'http://chilipiper.com',
    linkedinUrl: 'https://linkedin.com/company/chilipiper',
    logoUrl:
      'https://images.crunchbase.com/image/upload/t_cb-default-original/v1462212943/qwqvuiccx0xc2tyy8vno.png',
    shortDescription:
      'Chili Piper is a meeting lifecycle automation platform that helps revenue teams increase their conversion rates.',
    longDescription: null,
    primaryLocation: '228 Park Ave S, New York, NY 10003, USA',
    secondaryLocation: null,
    headcount: '243',
    foundedYear: 2016,
    totalFunding: 54_350_000,
    numFundingRounds: 6,
    latestFundingStage: 'UNKNOWN',
    industry: 'B2B,Enterprise Software,Meeting Software,Productivity Tools,SaaS,Sales,Software',
    sector: null,
    annualRevenue: null,
    ceoName: null,
    founders: null,
    acquired: false,
    acquiredBy: null,
    aliases: null,
    allInvestors: null,
    emails: ['support@chilipiper.com'],
    phones: ['(571) 425-3077'],
    crunchbaseUrl: null,
    pitchbookUrl: null,
    facebookUrl: 'https://www.facebook.com/TeamChiliPiper',
    twitterUrl: 'https://x.com/chilipiper',
    lastEnrichmentRequestId: null,
    lastFundingRaised: null,
    postValuation: null,
    recentNews: null,
  },
];
